// extracted by mini-css-extract-plugin
export var buttonClose = "menu-close-button-module--button-close--D7k7I";
export var closing = "menu-close-button-module--closing--IHvWg";
export var zoomIn = "menu-close-button-module--zoom-in--zyl4I";
export var zoomOut = "menu-close-button-module--zoom-out--mEzAn";